import {DefaultButton, Link, PanelType} from "@fluentui/react";

import React from "react";
import {IValidateExtensionResponse} from "../../models/Extension";
import PanelWrapper from "../Common/PanelWrapper";
import MarkdownView from "react-showdown";

interface IExtensionValidationErrorModalProps {
    errorDetails?: IValidateExtensionResponse;
    displayModal: boolean;
    closer: () => void;
}
const ExtensionValidationErrorModal: React.FC<IExtensionValidationErrorModalProps> = props => {

    return (
        <PanelWrapper
            isOpen={props.displayModal}
            onDismiss={props.closer}
            title={props.errorDetails?.success ? 'Extension Validation Warning' : 'Extension Validation Error'}
            type={PanelType.largeFixed}
            isFooterAtBottom={true}
            footerButtons={
                [
                    <DefaultButton
                    primary
                    text='OK'
                    onClick={() => {
                        props.closer();
                    }}
                    />
                ]}
        >
            <h3>{props.errorDetails?.success ? 'Warnings' : 'Errors'}</h3>
            {props.errorDetails?.validationMessages && props.errorDetails.validationMessages.length > 0 &&
                <ul>
                    {props.errorDetails.validationMessages.map((message, index) => (
                        <li key={index}>
                            <MarkdownView markdown={message}></MarkdownView>
                        </li>
                    ))}
                </ul>
            }
            <div>
                {props.errorDetails?.documentationUrl &&
                    <Link href={props.errorDetails.documentationUrl} target={"_blank"}>
                        More Information...
                    </Link>
                }

            </div>
        </PanelWrapper>

    );
}
export default ExtensionValidationErrorModal;